import { useState } from "react";

const RangeInput = ({ field, setFieldValue, values }) => {
  const [value, setValue] = useState(values[field.name] || 50);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    setFieldValue(field.name, newValue);
  };

  return (
    <div className="w-full max-w-md p-4">
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-500 text-sm">{field.label}</span>
        </div>
        <div className="relative pt-4">
          <div className="h-2 rounded-full bg-gray-200 overflow-hidden flex">
            <div
              className="bg-[#F4A460] border-r-4 border-white transition-all duration-200"
              style={{ width: `${value}%` }}
            />
          </div>

          <div
            className="absolute top-0 transform -translate-y-full transition-all duration-200"
            style={{ left: `${value}%` }}
          >
            <div className="relative -translate-x-1/2">
              <div className="w-8 h-8 rounded-full bg-[#483D8B] flex items-center justify-center">
                <span className="text-white text-xs font-medium">{value}</span>
              </div>
            </div>
          </div>

          <input
            type="range"
            min="0"
            max="100"
            value={value}
            onChange={handleChange}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            aria-label="Adjust sensitivity"
          />
        </div>
      </div>
    </div>
  );
};

export default RangeInput